const Style = ({ attributes, clientId }) => {
	const { gallery, itemHeight, columnGap, rowGap, background, shadow, hoverShadow, titleTypo, subtitleTypo } = attributes;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${titleTypo?.googleFontLink ? `@import url(${titleTypo?.googleFontLink})` : ''}
			${subtitleTypo?.googleFontLink ? `@import url(${subtitleTypo?.googleFontLink})` : ''}

			#bigbImageGallery-${clientId} .bigbImageGallery .galleryItems{
				grid-gap: ${rowGap} ${columnGap};
			}
			#bigbImageGallery-${clientId} .bigbImageGallery .galleryItem{
				height: ${itemHeight};
				${background?.styles || 'background: linear-gradient(#ff5f6d, #ffc371);'}
				box-shadow: ${shadow?.styles || '0 4px 4px 0 #000a1459'};
			}
			#bigbImageGallery-${clientId} .bigbImageGallery .galleryItem:hover, #bigbImageGallery-${clientId} .bigbImageGallery .galleryItem.nowEditing{
				box-shadow: ${hoverShadow?.styles || '0 12px 20px -12px #000a14cc'};
			}
			#bigbImageGallery-${clientId} .bigbImageGallery .galleryHeader h3{
				${titleTypo?.styles || 'font-size: 48px;'}
			}
			#bigbImageGallery-${clientId} .bigbImageGallery .galleryHeader h5{
				${subtitleTypo?.styles || 'font-size: 20px;'}
			}
			`.replace(/\s+/g, ' ')
		}} />
		<style>
			{gallery?.map((item, index) => {
				const { colors, btnColors } = item;

				const galleryItemHeader = `#bigbImageGallery-${clientId} .bigbImageGallery #galleryItem-${index} .galleryHeader`;
				const galleryItemFooter = `#bigbImageGallery-${clientId} .bigbImageGallery #galleryItem-${index} .galleryFooter`;

				const btnColor = btnColors.color;
				const btnBG = 'gradient' === btnColors.bgType ? btnColors.gradient : btnColors.bg;

				return `
					${galleryItemHeader}::before,
					${galleryItemFooter}::before{
						background: ${'gradient' === colors.bgType ? colors.gradient : colors.bg};
					}
					${galleryItemHeader} h3,
					${galleryItemHeader} h5{
						color: ${colors.color};
					}

					${galleryItemHeader} .btnClose{
						color: ${btnColor};
						background: ${btnBG};
					}
					${galleryItemFooter} nav.controls .control{
						background: ${btnBG};
					}
					${galleryItemFooter} nav.controls .controlDot{
						background: ${btnBG};
					}
					${galleryItemFooter} nav.controls .controlDot::after{
						background-color: ${btnColor};
					}
					${galleryItemFooter} nav.controls .controlArrow{
						color: ${btnColor};
					}
				`.replace(/\s+/g, ' ');
			})}
		</style>
	</>;
}
export default Style;